import React from 'react'
import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'
import Free from './preset/Free'
import Nomx from './preset/Nomx'
import Noml from './preset/Noml'
import NyStyle from './preset/NyStyle'
import SpeedBoard from './preset/SpeedBoard'
import ConsNomx from './preset/ConsNomx'
import PassQuiz from './preset/PassQuiz'
import Nbym from './preset/Nbym'
import TimeRace from './preset/TimeRace'
import Updown from './preset/Updown'
import Swedish from './preset/Swedish'
import Backstream from './preset/Backstream'
import Freeze from './preset/Freeze'
import Divide from './preset/Divide'
import Survival from './preset/Survival'
import BigWave from './preset/BigWave'

const PresetRuleBox = styled(Box)(
  ({ theme }) => `
  .MuiAccordionSummary-root {
    background-color: ${theme.palette.lightBack.primary};
  }
`
)

const PresetRule = ({ rule, setRule }) => {
  const [accordionExpanded, setAccordionExpanded] = React.useState(null)

  React.useEffect(() => {
    if (rule.preset) {
      setAccordionExpanded(rule.preset.name)
    }
  }, [rule])

  const onAccordionChange = panel => (evt, isExpanded) => {
    setAccordionExpanded(isExpanded ? panel : false)
  }

  return (
    <PresetRuleBox>
      <Free accordionExpanded={accordionExpanded}
            onAccordionChange={onAccordionChange}
            rule={rule} setRule={setRule} />
      <Nomx accordionExpanded={accordionExpanded}
            onAccordionChange={onAccordionChange}
            rule={rule} setRule={setRule} />
      <Noml accordionExpanded={accordionExpanded}
            onAccordionChange={onAccordionChange}
            rule={rule} setRule={setRule} />
      <NyStyle accordionExpanded={accordionExpanded}
               onAccordionChange={onAccordionChange}
               rule={rule} setRule={setRule} />
      <SpeedBoard accordionExpanded={accordionExpanded}
                  onAccordionChange={onAccordionChange}
                  rule={rule} setRule={setRule} />
      <ConsNomx accordionExpanded={accordionExpanded}
                onAccordionChange={onAccordionChange}
                rule={rule} setRule={setRule} />
      <PassQuiz accordionExpanded={accordionExpanded}
                onAccordionChange={onAccordionChange}
                rule={rule} setRule={setRule} />
      <Nbym accordionExpanded={accordionExpanded}
            onAccordionChange={onAccordionChange}
            rule={rule} setRule={setRule} />
      <TimeRace accordionExpanded={accordionExpanded}
                onAccordionChange={onAccordionChange}
                rule={rule} setRule={setRule} />
      <Updown accordionExpanded={accordionExpanded}
              onAccordionChange={onAccordionChange}
              rule={rule} setRule={setRule} />
      <Swedish accordionExpanded={accordionExpanded}
               onAccordionChange={onAccordionChange}
               rule={rule} setRule={setRule} />
      <Backstream accordionExpanded={accordionExpanded}
                  onAccordionChange={onAccordionChange}
                  rule={rule} setRule={setRule} />
      <Freeze accordionExpanded={accordionExpanded}
              onAccordionChange={onAccordionChange}
              rule={rule} setRule={setRule} />
      <Divide accordionExpanded={accordionExpanded}
              onAccordionChange={onAccordionChange}
              rule={rule} setRule={setRule} />
      <Survival accordionExpanded={accordionExpanded}
                onAccordionChange={onAccordionChange}
                rule={rule} setRule={setRule} />
      <BigWave accordionExpanded={accordionExpanded}
               onAccordionChange={onAccordionChange}
               rule={rule} setRule={setRule} />
    </PresetRuleBox>
  )
}

export default PresetRule
